<template>
  <b-modal
    id="update-file-upload-modal"
    v-model="openModal"
    size="lg"
    title="Mise à jour du fichier"
    static
  >
    <ValidationObserver ref="formValidator">
      <div class="update-file-form">
        <div class="form-row form-row-50">
          <div class="form-group col">
            <label 
              class="required"
              style="margin-top: 1em;"
            >
              {{ $t('resource.format.label') }}
            </label>
            <p>
              {{ $t('resource.format.help') }}
            </p>
            <ValidatedFileFormatSelector
              :required="true"
              validation-name="Format"
              :format-filter="
                format && format.codename ?
                  resourceDataFormats.find(el => el.codename === format.codename) :
                  null
              "
              :init-value="resourceDataFormats.find(el => el.codename === format.codename)"
              @select="onFormatSelect"
            />
            <p style="margin-top: 0.5em; font-size: 0.85em; white-space: wrap;">
              {{ $t('resource.fileUpload.formatHelp') }}
            </p>
          </div>
        </div>

        <ImportFile
          :type="'ressource'"
          name="main-resource"
          :accept="selectedFormat ?
            resourceDataFormats
              .find(el => el.codename === selectedFormat.codename).extension
              .map(el => { return `.${el}` }).join(',') :
            ''
          "
          :required="true"
          :disabled="selectedFormat === null"
          @update="setResourceFile"
        />
      
        <div
          v-if="resource.isGeospatial()"
          class="form-row"
          style="margin-top: 1.5rem;"
        >
         <div class="form-group col">
          <ResourceGeographicalLayer
            :key="`resource-geographical-layer-form-${resource.id}`"
            :resource="resource"
            :form-config="formConfig"
            :codename-disabled="true"
          />
          </div>
        </div>
      </div>
    </ValidationObserver>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-secondary"
          class="float-left"
          @click="cancel"
        >
          Annuler
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          @click="confirmUpdate"
        >
          Confirmer
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import { getCSVFileHeaders } from '@/utils/csv.js';

import ImportFile from '@/components/ImportFile.vue';
import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';
import { validateFormAndScroll } from '@/utils';
import { ValidationObserver, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import {
  ResourceGeographicalLayer
} from '@/app/resource/components';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'UpdateFileUploadModal',

  components: {
    ImportFile,
    ResourceGeographicalLayer,
    ValidatedFileFormatSelector,
    ValidationObserver,
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    format: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formConfig: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      openModal: false,
      selectedFormat: null,
      file: null,
    };
  },

  computed: {
    ...mapState('resources', [
      'resourceDataFormats'
    ]),
  },

  watch: {
    open: function(newValue) {
      this.openModal = newValue;
    }
  
  },

  created() {
    this.openModal = true;
  },

  methods: {
    cancel() {
      this.$emit('hide');
    },

    onFormatSelect(format) {
      this.selectedFormat = format;
      if (format && this.resource.fileupload) {
        this.$set(this.resource.fileupload, 'dataformat', format.codename);
      }
    },

    async confirmUpdate() {
      const isValid = await validateFormAndScroll(this.$refs.formValidator, this);
      if (isValid) {
        this.updateFileUploadFile();
      }
    },

    async setResourceFile(e) {
     
      this.resource.file=e;
      getCSVFileHeaders(e).then((header)=>{
        this.$set(this.resource, 'xyColumnsOptions', header);
      });
    },

    updateFileUploadFile() {
     
      this.$emit('update',this.resource);
      this.$emit('hide');
    }
  }
};
</script>

<style lang="less" scoped>
h2 {
  color: @blue;
  margin-top: 0.8em;
  margin-left: 0.5em;
}

.update-file-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  .form-row {
    width: 80%;
  }
  .form-row-50 {
    width: 50%;
    margin: auto;
  }
}

p {
  width: 100%;
  color: grey;
  font-style: italic;
  font-size: 0.7em;
  margin-bottom: 0.2em;
}

</style>
